import React from "react";

import { FormattedHTMLMessage } from "react-intl";
import { AnnouncingHeader } from "@/components/AnnouncingHeader/AnnouncingHeader";
import { IDCheckLoopResponse, VerificationService } from "../../../../lib/types/types";
import { StepCardComponent } from "../../StepCard/StepCard";
import IdCheckLoopRegulaFooter from "../../IdCheckLoopFooter/IdCheckLoopRegulaFooter";
import { IdCheckLoopRegulaComponent } from "../IdCheckLoopRegula/IdCheckLoopRegula";

export interface StepIDCheckLoopRegulaProps {
  verificationService: VerificationService;
}

const StepIDCheckLoopRegula = ({ verificationService }: StepIDCheckLoopRegulaProps) => {
  const verificationResponse = verificationService.verificationResponse as IDCheckLoopResponse;

  const [showUpload, setShowUpload] = React.useState<boolean>(false);

  React.useEffect(() => {
    if (verificationResponse && verificationResponse?.errorIds?.length > 0) {
      setShowUpload(true);
    }
  }, [verificationResponse]);

  return (
    <div id="sid-step-id-check-loop" className="sid-l-container">
      {showUpload ? (
        <div role="main">
          <IdCheckLoopRegulaComponent verificationService={verificationService} />
        </div>
      ) : (
        <>
          <div role="main">
            <AnnouncingHeader align="center">
              <FormattedHTMLMessage
                id="step.idCheckLoop.regula.title"
                defaultMessage="To continue, we need to verify your identity."
              />
            </AnnouncingHeader>
            <div className="sid-header__subtitle sid-l-horz-center sid-l-space-btm-md">
              <FormattedHTMLMessage
                id="step.idCheckLoop.subtitle"
                defaultMessage="To complete the verification process, we ask that you provide us with:"
              />
            </div>
            <div className="sid-identity-check-steps">
              <StepCardComponent
                title="Photo of a government-issued ID"
                subtitle="Drivers license, state ID, passport, or residence permit."
                icon={
                  <img
                    className="sid-identity-check-steps__icon"
                    alt=""
                    src="https://assets-resources.sheerid.com/common/images/2018/icons/upload-proof.svg"
                  />
                }
                isHighlighted
                key=""
              />
            </div>

            <div className="sid-submit sid-l-horz-center sid-l-space-top-md sid-l-space-btm-md">
              <button
                onClick={() => setShowUpload(!showUpload)}
                type="button"
                className="sid-btn sid-btn--dark"
                aria-label="submit"
              >
                <FormattedHTMLMessage id="step.idCheckLoop.continue" defaultMessage="Continue" />
              </button>
            </div>
          </div>
          <IdCheckLoopRegulaFooter verificationService={verificationService} />
        </>
      )}
    </div>
  );
};

export default StepIDCheckLoopRegula;
